<section class="groove-section-odd">
  <div class="groove-section-odd__section">
    <article class="groove-section-odd__background"
      [ngStyle]="{ 'background-image': 'url(' + imageDescription.url + ')'}" *ngIf="imageDescription">
      <div class="container groove-section-odd__content">
        <section class="row">
          <article class="homepage-section__column col-lg-6">
            <div class="homepage-section__caption">
              <fitscovery-ui-markdown-viewer [content]="imageDescription.caption!"></fitscovery-ui-markdown-viewer>
            </div>
            <div class="homepage-section__description">
              <fitscovery-ui-markdown-viewer [content]="imageDescription.description!"></fitscovery-ui-markdown-viewer>
            </div>
            <div class="homepage-section__buttons">
              <ng-container *ngFor="let button of imageDescription.buttons">
                <div class="d-flex" [ngClass]="setButtonAlignmentClass(button)">
                  <fitscovery-ui-custom-button class="mx-lg-0 mx-auto" [button]="button"
                    [email]="partner.contactInfo!.email" [homePageVersion]="partner.appConfig!.homePageVer!">
                  </fitscovery-ui-custom-button>
                </div>
              </ng-container>
            </div>
          </article>
          <article class="col-lg-6"></article>
        </section>
      </div>
      <div class="groove-section__banner-mobile mt-5">
        <img src="{{ imageDescription.url }}" alt="" class="w-100">
      </div>
    </article>
  </div>
</section>
